module.exports = __webpack_public_path__ + "img/biaoqian_jingqing.153d5d74.png";